import {events, ConfigService, RunConfigService, storage, util} from '@nuskin/ns-util';
import {UserService, AccountManager, VGDistInfoService} from '@nuskin/ns-account';
import GigyaUtil from './gigyaUtil.js';

/*
 params:
 destination - url to forward Ex. https://www.nuskin.com/content/nuskin/en_US/home.html
 cancel - url to go back to if login is cancelled Ex. https://www.nuskin.com/content/nuskin/en_US/home.html
 locale - language to show - Browser's locale will be used for displaying the login page.
 detail - basic, simple, and extended
 returnType - POST or GET
 country - country code Ex. US
 */

/**
 *Following Services
 *- list of bad usernames - if successful create a new username/gigya via existing create web account service.
 *- Forgot Password/Reset Password - no additional functionality needed
 *- Forgot Username - Put a SAP id and we will email the username to their registered email.
 *- Create Web Account - should be webcreate (signup)
 *- duplicate username - should be able to use same webcreate (signup)
 *
 * @namespace GigyaService
 */
var GigyaService = function() {
    "use strict";

    var nsConfig;
    var userService;
    var gigyaUtil;

    var urlTemplates = {
        scriptUrl: 'https://cdns.gigya.com/js/gigya.js?apiKey={apiKey}&lang={lang}',
        authorizeUrl:  '/account-util/api/v1/person/authorize?accountDetail={type}',
        personCreate:  '/account-util/api/v1/person/gigya/{personID}',
        passwordReset: '/account-util/api/v1/person/{username}/passwordChangeEmail',
        baseLoginUrl:  '/content/login/corp/{lang}.html',
        emailValidate: '/validate-service/api/v1/email/address.json?address={email}'
    };

    var urlPaths = {
        personCreate: '/account-util/api/v1/person/gigya/{personID}',
        baseLoginUrl: '/content/login/corp/{lang}.html',
        baseNewLoginUrl: '/content/login/corporate/{lang}.html'
    };

    var loginKeys = {
        AFTER_LOGIN_URL: "nuskin.account.afterLoginUrl",
        NEW_WINDOW_URL: "nuskin.account.newWindowUrl",
        AFTER_LOGIN_PARAMS: "nuskin.account.afterLoginParams"
    };

    var gigyaConfig = {
        scriptUrl: '',
        authorizeUrl: '',
        lang: '',
        apiKey: '',
        persistenceOption: '',
        environment: '',
        clientId: '',
        clientSecret: '',
        eid: '',
        isLoginPage: false,
        authorizeType: '',
        market: '',
        hasInitialized: false,
        storeUserInfoCallback: storeUserInfo,
        showScreenSetCallback: showScreenSet,
        hideScreenSetCallback: hideScreenSet,
        scriptLoadedCallback: null
    };

    var login = {
        userName: '',
        password: '',
        personID: '',
        eid: ''
    };

    var newUserAccountInfo = {
        username: '',
        password: ''
    };

    var loginRunConfig = {
        assessmentApp: false,
        language: '',
        country: '',
        siteConfigurationPath: ''
    };

    function callrememberMeService() {
        try {
            rememberMeService();
        } catch(e) {}
    }

    function showScreenSet() {
        gigya.accounts.showScreenSet({
            screenSet: 'Default-RegistrationLogin',
            lang: loginPageConfig.language,
            onError: errorHandler,
            onBeforeSubmit: formCheck,
            onAfterSubmit: loginResults,
            onAfterScreenLoad: callrememberMeService
        });
    }

    function hideScreenSet() {
        var params={
            screenSet: 'Default-RegistrationLogin'
        };
        gigya.accounts.hideScreenSet(params);
    }

    var init = function(config,callback) {
        gigyaUtil = new GigyaUtil();
        gigyaConfig.lang = 'en';
        if(location.pathname.indexOf("/login/corp") > -1) {
            gigyaConfig.isLoginPage = true;
            gigyaConfig.lang = loginPageConfig.language;
            if(loginPageConfig.hasMarket) {
                gigyaConfig.market = loginPageConfig.market;
                loginRunConfig.country = loginPageConfig.market;
                loginRunConfig.language = loginPageConfig.language;
                loginRunConfig.siteConfigurationPath = loginPageConfig.configurationPath;
                let url = window.location.href;
                let arr = url.split("/");
                loginRunConfig.baseUrl = arr[0] + "//" + arr[2];
                RunConfigService.setRunConfig(loginRunConfig);
            }

        }
        nsConfig = ConfigService.getMarketConfig();
        userService = UserService;

        gigyaConfig.type = 'basic';
        gigyaConfig.clientId = nsConfig.checkout.clientId;
        gigyaConfig.clientSecret = nsConfig.checkout.clientSecret;
            gigyaConfig.apiKey = nsConfig.gigyaApiKey;
        if(typeof(nsConfig.siteUrl) != 'undefined') {
            gigyaConfig.environment = nsConfig.siteUrl;
        } else {
            gigyaConfig.environment = nsConfig.globalAuthUrl.split('/simple')[0];
        }
        //       gigyaConfig.persistenceOption = config.persistenceOption;

        gigyaConfig.scriptUrl = urlTemplates.scriptUrl.replace('{apiKey}', gigyaConfig.apiKey).replace('{lang}', gigyaConfig.lang);
        if (nsConfig.useAwsAuthorizeService) {
            gigyaConfig.authorizeUrl = `${nsConfig.awsUrl}/authorize/v1?accountDetail=${gigyaConfig.type}`;
        } else {
            gigyaConfig.authorizeUrl = gigyaConfig.environment + urlTemplates.authorizeUrl.replace('{type}', gigyaConfig.type);
        }

        gigyaConfig.scriptLoadedCallback = callback;
        gigyaUtil.init(gigyaConfig);
        gigyaConfig.hasInitialized = true;
    };

    var lookupAvailablePoints = function() {
        if(nsConfig.enablePointsRedemption){
            var pointsPromise = $.ajax({
                type: "GET",
                url: nsConfig.nsurl_sapAdrStatusService + aem.AccountManager.currentData.id,
                data: {"countryGroup": util.countryCode, "eid": aem.AccountManager.currentData.eid},
                contentType: "text/plain; charset=utf-8",
                beforeSend: function(xhr) {
                    xhr.setRequestHeader("client_id", nsConfig.checkout.clientId);
                    xhr.setRequestHeader("client_secret", nsConfig.checkout.clientSecret);
                }
            });
        } else {
            var deferred = new $.Deferred();
            deferred.resolve();
            return deferred;
        }

        pointsPromise.done(function(response) {
            // AEM-8414 rudist still has the login popup after logging in
            // Basically, there is a javascript error for ADRPoints is undefined
            // Need to check if ADRPoints does NOT exists before doing the loop
            if (response.ADRMemberStatusResponse && response.ADRMemberStatusResponse.ADRPoints) {
                $.each(response.ADRMemberStatusResponse.ADRPoints, function(key, value) {
                    if(value.CountryCode === util.countryCode) {
                        var user = userService.getUser();
                        user.availablePoints = value.AvailablePoints;
                        userService.setUser(user);
                    }
                });
            }
        });

        pointsPromise.fail(function (error) {
            aem.AccountManager.currentData.availablePoints = 0;
            userService.setUser(aem.AccountManager.currentData);
        });

        return pointsPromise;
    };

    var loadVolumeData = function() {
        // let volumePromise;
        //
        // let volumeAccountUrl = util.getValue("nuskin.configuration.nsurl_accountService", "/account-service/api/v1/account");
        // volumeAccountUrl += "/simple/" + aem.AccountManager.currentData.id;
        // volumePromise = $.ajax({
        //     type: "GET",
        //     url: volumeAccountUrl,
        //     headers: {"client_id": nsConfig.checkout.clientId,"client_secret": nsConfig.checkout.clientSecret},
        //     data: {addVg: true, eid: aem.AccountManager.currentData.eid}
        // });
        //
        // //Only used to get circleGroupLeader
        // volumePromise.done(function(response) {
        //     AccountManager.currentData.isCircleGroupLeader = response.SimpleAccount.circleGroupLeader;
        //     userService.setUser(AccountManager.currentData);
        //     $.publish(events.account.VOLUME_ADDED, [AccountManager.currentData]);
        // });
        //
        // volumePromise.fail(function (error) {
        //     console.log(error);
        // });

        let vgDistInfoPromise = VGDistInfoService.getVGDistInfo();
        vgDistInfoPromise.then((distInfo) => {
            AccountManager.currentData.volumes = VGDistInfoService.formatVolumeData(distInfo.data.volume);
            AccountManager.currentData.highestRank = distInfo.data.highRank;
            AccountManager.currentData.displayName = distInfo.data.displayName;
            UserService.setUser(AccountManager.currentData);
            $.publish(events.account.VOLUME_ADDED, [AccountManager.currentData]);
        }).catch((error) => {
            console.error("VGDistInfoSevice Exception: ", error);
        });

        return vgDistInfoPromise;
    };

    function storeUserInfo (userData, useRedirect) {
        var loginTime = new Date().getTime(),
            resultObject = {
                "id": userData.id,
                "name": userData.name,
                "localName": userData.localName,
                "email": userData.email,
                "accountType": getAccountType(userData.customerType),
                "countryCd": userData.country,
                "priceType": userData.priceType,
                "encryptedId": userData.eid,
                "customerType": getCustomerType(userData.customerType),
                "eid": userData.eid,
                "lastName": userData.lastName,
                "firstName": userData.firstName,
                "loginTime": loginTime,
                'personId':userData.personId,
                'federatedId':userData.federatedId,
                'isVolumesLoaded': false
            };

        if (!userData.temporary) {
            nsConfig.skipSignonRedirect = true;
        }

        resetOPSCookies();
        userService.setUser(resultObject);
        userService.setLoggedIn(true);
        login.eid = userData.eid;
        gigyaUtil.writeEid(userData.eid, userData.adminMode);
        if (gigyaConfig.isLoginPage) {
            aem.AccountManager.currentData = resultObject;
            if(loginPageConfig.useRedirect) {
                redirectToPage(userData);
            }
        }
    }

    function resetOPSCookies() {
        var keys = storage.keys;
        var domain = location.host.substr(location.host.indexOf("."));
        $.cookie("custtype", null, {path:'/', domain: domain, expires: -1});
    }

    function getAccountType(custType) {
        if (custType == 'DIST' || custType == 'DISTRIBUTOR') {
            return "10";
        } else if (custType == 'CUST' || custType == 'CUSTOMER') {
            return "20";
        } else if (custType == 'PREF' || custType == 'PREFERREDCUST' || custType == 'PREFERRED') {
            return "30";
        } else {
            return "0";
        }
    }

    function getCustomerType(custType) {
        if (custType == 'DIST') {
            return "DISTRIBUTOR";
        } else if (custType == 'CUST') {
            return "CUSTOMER";
        } else if (custType == 'PREF' || custType == 'PREFERRED') {
            return "PREFERREDCUST";
        } else {
            return "";
        }
    }

    function writeLTOCookie(ltoData) {
        var EID_DEFAULT_PERIOD = 20 * 1000; // 60 seconds (in ms)
        var expires = new Date();
        expires.setTime(expires.getTime() + EID_DEFAULT_PERIOD);
        $.cookie("gigyalto", JSON.stringify(ltoData), {path: "/", expires: expires});
    }

    function redirectToPage(userData) {
        try {
            gigya.accounts.logout();
        }catch(e) {}
        var redirectURL = destinationURL;
        if (AccountManager.isPreferredCustomer() && aem.util.usePreferredCustomerRedirect && destinationURL.indexOf("pfc_conversion") === -1) {
            redirectURL = aem.util.preferredCustomerRedirectURL;
        } else if(AccountManager.currentData.accountType == "10" && !aem.util.usePreferredCustomerRedirect) {
            redirectURL = dashboardURL;
        }
        if(typeof(passEid) != 'undefined' && passEid.length > 0) {
            redirectURL = aem.nuskin.util.Url.addParam(redirectURL,'eid',login.eid);
        }
        if(loginPageConfig.isLTO) {
            var ltoData =
            { 'ltoValidateLogin' : loginPageConfig.ltoValidateLogin};
            //   var ltoQueryParams = '?ltoValidateLogin=' + loginPageConfig.ltoValidateLogin;
            if(loginPageConfig.ltoPromoCode.length > 0) {
                //       ltoQueryParams = '?ltoValidateLogin=' + loginPageConfig.ltoValidateLogin + '&promocode=' + loginPageConfig.ltoPromoCode;
                ltoData.promocode = loginPageConfig.ltoPromoCode;
            }

            if (loginPageConfig.allowedPrefixes) {
                let userPrefix = userData.id.substring(0, 2);
                let prefixList = loginPageConfig.allowedPrefixes.split(" ");
                if (!_.includes(prefixList, userPrefix)) {
                    if (gigyaUrlData) {
                        ltoData = gigyaUrlData;
                    }
                    if (document.URL.indexOf("?") !== -1) {
                        redirectURL = document.URL + "&disallowedPrefix=" + userPrefix;
                    } else {
                        redirectURL = document.URL + "?disallowedPrefix=" + userPrefix;
                    }
                }
            }
            writeLTOCookie(ltoData);
            window.location = redirectURL;
        } else if (loginPageConfig.isMicrosite) {
            window.location = aem.nuskin.util.Url.decodeParameter(redirectURL);
        }  else {
            gotoDestination(aem.nuskin.util.Url.decodeParameter(redirectURL));
        }
    }


    function loginResults(eventObj){
        if (eventObj.response.status === 'FAIL'){
            $('#gigyaErrorLayoutID').show();
        } else {
            $('#gigyaErrorLayoutID').hide();
        }
    }

    // Start of loginPage functions

    function formCheck(eventObj){
        login.userName = eventObj.formData.loginID;
        login.password = $("input[name='password']").val();
    }

    function displayChangeUserAccountUI() {
        hideScreenSet();
        $('#change-credentials').show();
    }

    function displayForgotPasswordUI() {
        hideScreenSet();
        $('#reset-password').show();
    }

    function isAvailableLoginIDCallback (response) {
        if(response.isAvailable) {
            // display: none
            createGigyaAccount();
        } else {
            // display error
        }
    }

    function isAvailableLoginIDCall() {
        var idParams = {
            loginID:newUserAccountInfo.userName,
            callback: isAvailableLoginIDCallback
        };
        gigya.accounts.isAvailableLoginID(idParams);
    }

    function isAvailableLoginID() {
        newUserAccountInfo.userName = $('#newUsernameInput').val();
        newUserAccountInfo.password = $('#newPasswordInput').val();
        if(newUserAccountInfo.password == login.password) {
            validationErrors(true);
        } else {
            validatePasswordEmail(newUserAccountInfo.userName);
        }
    }

    function resetPassword() {
        var userId = $('#username-id').val();
        var resetPasswordUrl = urlTemplates.passwordReset.replace('{username}', userId);

        $.ajax({
            type: "GET",
            url: resetPasswordUrl,
            contentType: "application/json",
            dataType: 'json',
            headers: {
                client_id: gigyaConfig.clientId,
                client_secret: gigyaConfig.clientSecret,
                Accept: 'application/json'
            }
        }).done(function (response) {
            if(response.String == 'SUCCESS') {
                $('#reset-password').hide();
                showScreenSet();
            } else {
                $('#forgotPasswordEnterId-Error').show()
            }
        }).fail(function () {
            $('#forgotPasswordEnterId-Error').show()
        });
    }

    function validationErrors(isPassword,errorMsg) {
        try {
            if(isPassword) {
                Form.password.confirmed = false;
                Form.password.firstValue = null;
                Form.password.element.value = "";
                Form.password.broadcastToSubscribers({id: 'newUsernameInput', valid: false});
                Form.password.showInfoMessage(errorMsg, "warning");
                Form.password.fieldset.classList.remove('valid');
            } else {
                Form.username.confirmed = false;
                Form.username.firstValue = null;
                Form.username.element.value = "";
                Form.username.broadcastToSubscribers({id: 'newUsernameInput', valid: false});
                Form.username.showInfoMessage(errorMsg, "warning");
                Form.username.fieldset.classList.remove('valid');
            }
        }catch(e) {}
    }


    function validatePasswordEmail(email) {
        var emailValidateUrl = urlTemplates.emailValidate.replace('{email}', email);
        $.ajax({
            type: "GET",
            url: emailValidateUrl,
            contentType: "application/json",
            dataType: 'json',
            headers: {
                client_id: gigyaConfig.clientId,
                client_secret: gigyaConfig.clientSecret,
                Accept: 'application/json'
            }}).done( function(response) {
                if(response.valid) {
                    isAvailableLoginIDCall();
                } else {
                    validationErrors(false,loginPageErrorMsg.notValidEmail);
                }
            }).fail( function(response) {
                validationErrors(false,loginPageErrorMsg.notValidEmail);
            });
    }


    function silentLogin() {
        gigya.accounts.login({
            loginID: newUserAccountInfo.userName,
            password: newUserAccountInfo.password,
            format: 'jsonp',
            callback: silentLoginCallback
        });
    }

    function defaultScreen(response) {
        if (config.isLoginPage) {
            $('#wait-message').hide();
            showScreenSet();
        }
    }

    function createGigyaAccount() {
        var data = {
            "username": newUserAccountInfo.userName,
            "password": newUserAccountInfo.password
        };
        $.ajax({
            type: "POST",
            url: urlPaths.personCreate.replace('{personID}', login.personID),
            contentType: "application/json",
            data: JSON.stringify(data),
            dataType: 'json',
            headers: {
                client_id: gigyaConfig.clientId,
                client_secret: gigyaConfig.clientSecret,
                eid: login.eid,
                Accept: 'application/json'
            }}).done( function(response) {
                if(response.status == 200) {
                    silentLogin();
                }
            }).fail( function(response) {
        });
    }

    function errorHandler(response) {
        // perform account lookup to see if case sensitive
    }


    function silentLoginCallback(response) {
        gigyaUtil.userInfoCall(response);
    }

    function isGigyaInitialized() {
        var gigyaInitialized = true;
        if(gigyaUtil == undefined) {
            init(null,scriptLoadedCallbackLogout);
            gigyaInitialized = false;
        }
        return gigyaInitialized;
    }

    var scriptLoadedCallbackLogout = function() {
        logout();
    };

    var scriptLoadedCallback = function() {
    };

    function logout() {
        if(gigyaConfig.hasInitialized) {
            gigyaUtil.logout();
            localStorage.removeItem('nuskin.account.data');
            localStorage.removeItem('nuskin.account');
        }
    }

    function gotoDestination(returnUrl) {
        var params = getAfterLoginParams() || {};

        if (params.skipSignonRedirect || util.getValue(nsConfig.skipSignonRedirect, false)) {
            window.location = returnUrl;
        } else {
            if(!returnUrl.startsWith("http")) {
                returnUrl = nuskin.configuration.siteUrl + returnUrl;
            }
            returnUrl = escape(returnUrl);
            var authUrl = RunConfigService.getRunConfig().baseUrl + "/signon/pnp/form.do?pnpSapId="+aem.AccountManager.currentData.id+"&pnpLang="+gigyaConfig.lang+"&pnpAcceptURL="+returnUrl+"&pnpRejectURL="+returnUrl+"&pnpErrorURL="+returnUrl;
            window.location = authUrl;
        }
    }

    function getAfterLoginParams() {
        var cookieString = $.cookie(loginKeys.AFTER_LOGIN_PARAMS);

        if (cookieString) {
            return JSON.parse(cookieString);
        }
        return null;
    }

    // End of loginPage functions


    var publicMethods = {

        /**
         * @memberof GigyaService
         * @example
         * GigyaService.goLogin()
         */
        goLogin : function() {
            addEventListeners();
        },

        /**
         * @memberof GigyaService
         * @example
         * GigyaService.logout()
         */
        logout : function() {
            logout();
        },

        /**
         * @memberof GigyaService
         * @example
         * var loginUrl = GigyaService.getNewLoginUrl(language)
         * @param language
         * @returns {string} loginUrl
         */
        getNewLoginUrl : function(language) {
            return urlPaths.baseNewLoginUrl.replace('{lang}', language);
        },

        /**
         * @memberof GigyaService
         * @example
         * var loginUrl = GigyaService.getLoginUrl(language)
         * @param language
         * @returns {string} loginUrl
         */
        getLoginUrl : function(language) {
            return urlPaths.baseLoginUrl.replace('{lang}', language);
        },

        /**
         * @memberof GigyaService
         * @example
         * var loginUsernameAvailable = GigyaService.isAvailableLoginID()
         * @returns {boolean} loginUsernameAvailable
         */
        isAvailableLoginID: function() {
            isAvailableLoginID();
        },

        /**
         * @memberof GigyaService
         * @example
         * GigyaService.initialize(config,ssoEventCallback)
         * @param config
         * @param ssoEventCallback
         */
        initialize: function(config,ssoEventCallback) {
            init(config,ssoEventCallback);
        },

        /**
         * @memberof GigyaService
         * @example
         * GigyaService.showLogin()
         */
        showLogin : function() {
            gigyaConfig.isLoginPage = true;
            init(null,scriptLoadedCallback);
        },

        /**
         * @memberof GigyaService
         * @example
         * var browserName = GigyaService.resetPassword()
         */
        resetPassword: function() {
            resetPassword();
        },

        /**
         * @memberof GigyaService
         * @example
         * GigyaService.displayForgotPasswordUI()
         */
        displayForgotPasswordUI: function () {
            displayForgotPasswordUI();
        },

        /**
         * @memberof GigyaService
         * @example
         * var loginInfo = GigyaService.getLoginInfo()
         * @returns {object} loginInfo
         */
        getLoginInfo : function() {
            return login;
        },

        /**
         * @memberof GigyaService
         * @example
         * GigyaService.storeUserInfo(data)
         * @param {object} data
         */
        storeUserInfo : function(data) {
            storeUserInfo(data,false);
        }
    };

    return publicMethods;
}();
export default GigyaService;
